import analysisApi from '@/app/PageSpeed/api/analysisApi';
import accessLevelApi from '@/app/common/api/accessLevelApi';
import authApi from '@/app/common/api/authApi';
import socketApi from '@/app/common/api/socketApi';
import tableApi from '@/app/common/api/tableApi';
import tableSettingApi from '@/app/common/api/tableSettingApi';
import wpHelpApi from '@/app/common/api/wpHelpApi';
import notifApi from '@/app/common/api/notifApi';
import changelogApi from '@/app/common/api/changelogApi';
import crawlApi from '@/app/Crawl/api/crawlApi';
import domainsApi from '@/app/Domain/api/domainsApi';
import clusteringApi from '@/app/KeywordResearch/api/clusteringApi';
import gapApi from '@/app/KeywordResearch/api/gapApi';
import gscApi from '@/app/KeywordResearch/api/gscApi';
import keywordPlannerApi from '@/app/KeywordResearch/api/keywordPlannerApi';
import keywordRelatedApi from '@/app/KeywordResearch/api/keywordRelatedApi';
import massiveApi from '@/app/KeywordResearch/api/massiveApi';
import searchVolumeApi from '@/app/KeywordResearch/api/searchVolumeApi';
import keywordTrackerApi from '@/app/KeywordTracker/api/keywordTrackerApi';
import ordersApi from '@/app/Purchase/api/ordersApi';
import pricingApi from '@/app/Pricing/api/pricingApi';
import priceApi from '@/app/Report/api/priceApi';
import priceNewApi from '@/app/Report/api/priceNewApi';
import reportApi from '@/app/Report/api/reportApi';
import serpApi from '@/app/Serp/api/serpApi';
import aiApi from '@/app/KeywordTracker/api/aiApi';
import aiContentToolsApi from '@/app/ContentTools/api/aiContentAnalysisApi';
import aiKeywordsApi from '@/app/KeywordResearch/api/aiKeywordsApi';
import apiKeyApi from '@/app/common/api/apiKeyApi';
import walletApi from '@/app/Wallet/api/walletApi';
import aiSettingsApi from '@/app/Settings/api/aiSettingsApi';
import inappApi from '@/app/common/api/notifications/inappApi';
import tooltipsApi from '@/app/common/api/tooltipsApi';
import trackerAiApi from '@/app/TrackerAi/api/trackerAiApi';
import mcpApi from '@/app/Mcp/api/mcpApi';
import mcpPdfApi from '@/app/Mcp/api/mcpPdfApi';
import indexerApi from '@/app/Indexer/api/indexerApi';
import '@/app/TrackerAi/api/trackerEndpointsApi';
import '@/app/BacklinkNew/api/registerBacklinkEndpoints';
import backlinkNewApi from '@/app/BacklinkNew/api/backlinkNewApi';

const services = [
  domainsApi,
  indexerApi,
  gscApi,
  authApi,
  socketApi,
  crawlApi,
  tableApi,
  tableSettingApi,
  accessLevelApi,
  wpHelpApi,
  serpApi,
  keywordPlannerApi,
  searchVolumeApi,
  keywordTrackerApi,
  priceApi,
  priceNewApi,
  clusteringApi,
  massiveApi,
  gapApi,
  keywordRelatedApi,
  ordersApi,
  pricingApi,
  analysisApi,
  reportApi,
  notifApi,
  changelogApi,
  inappApi,
  tooltipsApi,
  aiApi,
  aiContentToolsApi,
  aiKeywordsApi,
  apiKeyApi,
  walletApi,
  aiSettingsApi,
  trackerAiApi,
  mcpApi,
  mcpPdfApi,
  backlinkNewApi
];
export default services;
